module.exports = __webpack_public_path__ + "img/warning.0343b7f0.svg";